// Model.js
// -----------------------
// @module Case
define("BTM.PDPRecentlyViewedItems.PDPRecentlyViewedItems.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/PDPRecentlyViewedItems/SuiteScript2/PDPRecentlyViewedItems.Service.ss"
            ),
            true
        )
});
});
